import React from 'react';
import { VideoProvider } from './Video';

interface VideoThumbnailProps {
    videoId?: string;
    isActive?: boolean;
    provider?: string;
    thumbnail?: string;
}

const VideoThumbnail: React.FC<VideoThumbnailProps> = ({ videoId, isActive, provider, thumbnail }) => {

    const thumbnailUrl = provider === VideoProvider.YOUTUBE
    ? `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`
    : provider === VideoProvider.VIMEO
    ? `https://vumbnail.com/${videoId}.jpg`
    : thumbnail;

    return (
        <div className={`thumbnail-carousel__thumbnail ${isActive? 'active-thumbnail' : ''}`}>
            <img src={thumbnailUrl} alt="Video Thumbnail" />
            <span className="play-button svg-play-with-circle-white"/>
        </div>
    );
};

export default VideoThumbnail;